<p>template-dialog WIP</p>
